import { Component, inject, input, output } from '@angular/core';
import { Article, Topic } from './help.domain';
import { HelpService } from './help.service';

@Component({
  selector: 'td-wb-help-article-index',
  templateUrl: 'help-article-index.component.html',
  styleUrls: ['help-article-index.component.scss']
})
export class HelpArticleIndexComponent {
  private readonly helpService = inject(HelpService);

  readonly topic = input<Topic>(undefined);
  readonly articles = input<Array<Article>>(undefined);
  readonly articleSelected = output<string>();

  scrollToArticle(articleId: string): void {
    if (this.articles().some((item: Article): boolean => item.id === articleId)) {
      this.helpService.scrollToArticle(articleId);
    }
    this.articleSelected.emit(articleId);
  }

  scrollToLink(linkId: string): void {
    this.helpService.scrollToLink(linkId);
  }
}
